/* unplugin-vue-components disabled */import script from "./Page.vue?vue&type=script&setup=true&lang=js"
export * from "./Page.vue?vue&type=script&setup=true&lang=js"

import "./Page.vue?vue&type=style&index=0&id=09069db2&lang=scss"

const __exports__ = script;

export default __exports__